(function( $ ) {
    'use strict';

    if (window.location.href.indexOf("refer-a-friend") === -1) {
        // only run this on the appropriate page
        return;
    }

    $( window ).load(function() {
        //Show button share apple wallet
        if (window.utils.system.isIOS()) {
            document.getElementsByClassName("share-klira-pass")[0].classList.remove('hidden')
        }
        // when inputting the email address to refer, this updates the button so that the link sends mailto the correct email.
        document.querySelector('input[name="ref-email"]').addEventListener(
            'input',
            window.utils.debounce(
                function(e) {
                    const rafLink = document.querySelector('.referral-url .url').textContent;

                    document.querySelector('#send-raf').href = `mailto:${e.target.value}?subject=Get £20 off at Klira&body=${rafLink}%0D%0DIf you don't want me to send you these types of offers just let me know.`
                },
                500
            )
        )
    });
})( jQuery );
